import { render } from "./PaymentMethodModal.vue?vue&type=template&id=d2aa0bc0"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js"

import "./PaymentMethodModal.vue?vue&type=style&index=0&id=d2aa0bc0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__